export const waitForTransitionEnd = (callback: () => void, timeout = 300): void => {
  setTimeout(callback, timeout);
};
